<template>
  <div class="b_inter_wrap">
    <step-status :step="$route.meta.step" class="mt55"></step-status>
    <div class="book_date">
      <h4>Request an Interview Time</h4>
      <dl class="timeZone">
        <dt>
          <el-select v-model="time_zone" filterable placeholder="Your current time zone＊  ">
            <el-option v-for="(key, val) of datas_time.time_zone" :label="val" :value="key" :key="key">
            </el-option>
          </el-select>
        </dt>
        <dd>The interview times listed below are presented </br> according to the time zone you selected</dd>
      </dl>
      <div class="date_detail clearfix">
        <div class="calendar_wrapper">
          <!-- <p>{{calendar.items.text}}</p>  -->
          <Calendar :show="calendar.show" :type="calendar.items.type" :value="calendar.items.value" :x="calendar.x" :y="calendar.y" :begin="calendar.items.begin" @cancel="dateCancel" @ok="dateOk" :end="calendar.items.end" :sep="calendar.items.sep" :single="calendar.items.single" :rangeValue='calendar.items.rangeValue' :autoclose='calendar.items.autoclose'>
          </Calendar>
        </div>
        <div class="date_time clearfix">
          <p class="no_times" v-show='!dayOne'>No available times that day, please check other dates.</p>
          <ul class="time_quantum clearfix" v-show='dayOne'>
            <li>
              <h4>Morning</h4>
              <ul class="time_list clearfix">
                <li v-for="(item, index) in time_slot.morning" :key="index" :class="{active:item.isActive}" @click="MchoseFn(index,'morning')">{{item.name}}</li>
              </ul>
            </li>
            <li>
              <h4>Afternoon</h4>
              <ul class="time_list clearfix">
                <li v-for="(item, index) in time_slot.afternoon" :key="index" :class="{active:item.isActive}" @click="MchoseFn(index,'afternoon')">{{item.name}}</li>
              </ul>
            </li>
            <li>
              <h4>Evening</h4>
              <ul class="time_list clearfix">
                <li v-for="(item, index) in time_slot.evening" :key="index" :class="{active:item.isActive}" @click="MchoseFn(index,'evening')">{{item.name}}</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
      <a href="javascript:;" class="submit" @click="submitFn"> Submit</a>
      <img v-if='addPixel' src="https://pixel.appcast.io/homegrown-9k/a17.png?ent=0&e=4405&t=1506715226" style="display: none;" width="1px" height="1px" />
      <!-- Google pixel -->
      <div style="display:inline;" v-if='$route.query.status=="unassigned"'>
        <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=muXOCOXCsngQu9OslgM&amp;guid=ON&amp;script=0" />
      </div>
      <!-- 渠道统计 -->
      <img v-if="channelStatus" src="https://click.appcast.io/generic-9k/a17.png?ent=147&e=5728&t=1523371553225" style="display: none;" width="1px" height="1px" />
    </div>
  </div>
</template>
<script>
import Calendar from '@common/Calendar.vue'

export default {
  name: 'rangeTime',
  components: {
    Calendar
  },
  data() {
    return {
      // 数据绑定
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '', // "2015-08-20"
          end: '',
          text: '',
          value: '',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        }
      },
      datas: '',
      datas_time: '',
      time_zone: '',
      start_time: '',
      time_slot: {
        morning: [],
        afternoon: [],
        evening: []
      },
      book_cycles: '', //可选天数
      select_time: '', //获取当前点击的时间段,
      status: '',
      time_hour: '',
      after_second: '',
      dayOne: true,
      addPixel: false,
      channelStatus: false
    }
  },

  created: function() {
    //渠道统计
    this.axios.get('/Boarding/getTutor').then(d => {
      if (d.data.code == '75000') {
        if(d.data.res.info.source == 4 && d.data.res.info.source_details == 403){
          this.channelStatus = true
        }
      }
    })
    this.$http.get('/register/getSourceAndSourceDetail').then(function(d) {
      if (d.data.code == '75000' && d.data.res.source_details == '403') {
        this.addPixel = true
      }
    })
    //请求时区
    this.$http.get('/common/getConfig?key=time_zone').then(
      function(response) {
        if (response.data.code == '75000') {
          this.datas_time = response.data.res

          //获取应聘者当前时间的秒数
          let time = new Date().getTime()
          let second = parseInt(time / 1000)
          this.start_time = second

          this.$http
            .get(
              '/interview/getInterViewTime?start_time=' +
                this.start_time +
                '&is_first=1'
            )
            .then(
              function(response) {
                if (response.data.code == '75000') {
                  this.datas = response.data.res //保存返回数据
                  if (this.datas.is_book) {
                    //标记未来几天是否可约

                    this.book_cycles = this.datas.book_cycles //可约时间段
                    this.after_second = this.datas.after_second
                    //计算可约时间段的最后一天
                    let secondTime =
                      (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000 //获取可选天数毫秒数
                    let start_day = new Date(
                      this.datas.book_start_date
                    ).getTime()
                    let endTime = new Date(start_day + secondTime)
                    let year = endTime.getFullYear()
                    let months =
                      endTime.getMonth() + 1 < 10
                        ? '0' + (endTime.getMonth() + 1)
                        : endTime.getMonth() + 1
                    let day =
                      endTime.getDate() < 10
                        ? '0' + endTime.getDate()
                        : endTime.getDate()
                    this.calendar.items.end = year + '-' + months + '-' + day //结束日期

                    console.log(
                      this.datas.book_cycles,
                      this.datas.book_start_date,
                      this.calendar.items.end
                    )

                    //渲染日历表的起始时间和当前时间
                    this.calendar.items.begin = this.datas.book_start_date
                    this.calendar.items.value = this.datas.book_selected_date
                    this.calendar.items.text = this.datas.book_selected_date

                    this.calendar.show = false
                    this.calendar.show = true

                    this.time_zone = this.datas.selected_time_zone //时区赋值
                  } else if (this.datas.is_book == false) {
                    //无可约则跳到pending页面
                    this.$router.push('pending')
                  }
                }
              },
              function() {
                console.log('service error')
              }
            )
        }
      },
      function() {
        console.log('service error')
      }
    )

    //监视时区变化
    this.$watch(
      function() {
        return this.time_zone
      },
      function(o, n) {
        //获取应聘者当前时间的秒数
        let time = new Date().getTime()
        let second = parseInt(time / 1000)
        this.start_time = second

        this.$http
          .get(
            '/interview/getInterViewTime?start_time=' +
              this.start_time +
              '&time_zone=' +
              this.time_zone +
              '&is_first=1'
          )
          .then(
            function(response) {
              if (response.data.code == '75000') {
                this.datas = response.data.res //保存返回数据
                if (this.datas.is_book) {
                  //标记未来几天是否可约

                  //计算可约时间段的最后一天
                  let secondTime =
                    (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000 //获取可选天数毫秒数
                  let start_day = new Date(this.datas.book_start_date).getTime()
                  let endTime = new Date(start_day + secondTime)
                  let year = endTime.getFullYear()
                  let months =
                    endTime.getMonth() + 1 < 10
                      ? '0' + (endTime.getMonth() + 1)
                      : endTime.getMonth() + 1
                  let day =
                    endTime.getDate() < 10
                      ? '0' + endTime.getDate()
                      : endTime.getDate()
                  this.calendar.items.end = year + '-' + months + '-' + day //结束日期

                  //渲染日历表的起始时间和当前时间
                  this.calendar.items.begin = this.datas.book_start_date
                  this.calendar.items.value = this.datas.book_selected_date
                  if (
                    this.calendar.items.text == this.datas.book_selected_date
                  ) {
                    //如果返回有时间的天数没有改变
                    this.select_time = ''
                    //获取应聘者当前时间的秒数
                    let time = new Date().getTime()
                    let second = parseInt(time / 1000)
                    this.start_time = second

                    let textAttr
                    let secondDate
                    let secondDates
                    //如果当前所选天数是可选时间的第一天
                    if (this.calendar.items.text == this.calendar.items.begin) {
                      //所传小时是当前小时
                      secondDates = this.start_time * 1 + this.after_second * 1
                      console.log(
                        this.after_second,
                        this.start_time * 1,
                        this.after_second * 1,
                        secondDates
                      )
                    } else {
                      //所传小时是零点
                      textAttr = new Date(this.calendar.items.text + ' 00:00')
                      secondDate = textAttr.getTime()
                      secondDates = parseInt(secondDate / 1000) //时间戳格式化到秒数
                    }
                    console.log(secondDates)

                    this.$http
                      .get(
                        '/interview/getInterViewTime?start_time=' +
                          secondDates +
                          '&time_zone=' +
                          this.time_zone +
                          '&is_first=0&selected_date=' +
                          this.calendar.items.text
                      )
                      .then(
                        function(response) {
                          if (response.data.code == '75000') {
                            this.datas = response.data.res //保存返回数据
                            //每次请求都清空
                            this.time_slot.morning = []
                            this.time_slot.afternoon = []
                            this.time_slot.evening = []

                            if (this.datas.time_slot.length == 0) {
                              //判断如果所选日期没有可选时间段，提示无可选时间
                              this.dayOne = false
                            } else {
                              //所选日期有可选时间段

                              this.dayOne = true

                              function getArr(time_slot) {
                                //渲染可选时间段

                                var returnArr = {
                                  morning: [],
                                  afternoon: [],
                                  evening: []
                                }
                                var typeArr = [
                                  'morning',
                                  'afternoon',
                                  'evening'
                                ]
                                typeArr.forEach(function(item) {
                                  if (time_slot[item]) {
                                    for (
                                      let i = 0;
                                      i < time_slot[item].length;
                                      i++
                                    ) {
                                      returnArr[item].push({
                                        name: time_slot[item][i],
                                        isActive: false
                                      })
                                    }
                                  }
                                })
                                return returnArr
                              }
                              this.time_slot = getArr(this.datas.time_slot)
                            }
                          }
                        },
                        function() {
                          console.log('service error')
                        }
                      )
                  } else {
                    //如果返回有时间的天数改变直接赋值
                    this.calendar.items.text = this.datas.book_selected_date
                  }
                  this.calendar.show = false
                  this.calendar.show = true
                } else if (this.datas.is_book == false) {
                  //无可约则跳到pending页面
                  this.$router.push('pending')
                }
              }
            },
            function() {
              console.log('service error')
            }
          )
      }
    )

    //监视日期改变
    this.$watch(
      function() {
        return this.calendar.items.text
      },
      function(o, n) {
        this.select_time = ''
        //获取应聘者当前时间的秒数
        let time = new Date().getTime()
        let second = parseInt(time / 1000)
        this.start_time = second

        let textAttr
        let secondDate
        let secondDates
        //如果当前所选天数是可选时间的第一天
        if (this.calendar.items.text == this.calendar.items.begin) {
          //所传小时是当前小时
          secondDates = this.start_time * 1 + this.after_second * 1
          console.log(
            this.after_second,
            this.start_time * 1,
            this.after_second * 1,
            secondDates
          )
        } else {
          //所传小时是零点
          textAttr = new Date(this.calendar.items.text + ' 00:00')
          secondDate = textAttr.getTime()
          secondDates = parseInt(secondDate / 1000) //时间戳格式化到秒数
        }
        console.log(secondDates)

        this.$http
          .get(
            '/interview/getInterViewTime?start_time=' +
              secondDates +
              '&time_zone=' +
              this.time_zone +
              '&is_first=0&selected_date=' +
              this.calendar.items.text
          )
          .then(
            function(response) {
              if (response.data.code == '75000') {
                this.datas = response.data.res //保存返回数据
                //每次请求都清空
                this.time_slot.morning = []
                this.time_slot.afternoon = []
                this.time_slot.evening = []

                if (this.datas.time_slot.length == 0) {
                  //判断如果所选日期没有可选时间段，提示无可选时间
                  this.dayOne = false
                } else {
                  //所选日期有可选时间段

                  this.dayOne = true

                  function getArr(time_slot) {
                    //渲染可选时间段

                    var returnArr = {
                      morning: [],
                      afternoon: [],
                      evening: []
                    }
                    var typeArr = ['morning', 'afternoon', 'evening']
                    typeArr.forEach(function(item) {
                      if (time_slot[item]) {
                        for (let i = 0; i < time_slot[item].length; i++) {
                          returnArr[item].push({
                            name: time_slot[item][i],
                            isActive: false
                          })
                        }
                      }
                    })
                    return returnArr
                  }
                  this.time_slot = getArr(this.datas.time_slot)
                }
              }
            },
            function() {
              console.log('service error')
            }
          )
      }
    )
  },
  methods: {
    // 打开显示选择器
    open(e, type) {
      // 设置类型
      this.calendar.show = true
      this.calendar.x = e.target.offsetLeft
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8
    },
    dateCancel(obj) {
      this.calendar.show = obj.show
    },
    dateOk(obj) {
      this.calendar.items.text = obj.values[0]
      this.calendar.items.value = obj.values[0]
    },
    addZero: num => {
      num < 10 ? '0' + num : num
    },
    MchoseFn: function(index, partTime) {
      //时间段点击
      for (let item in this.time_slot) {
        var arrItem = this.time_slot[item]
        for (let i = 0; i < arrItem.length; i++) {
          arrItem[i].isActive = false
        }
      }
      let slotArr = this.time_slot
      slotArr[partTime][index].isActive = !slotArr[partTime][index].isActive
      this.select_time = slotArr[partTime][index].name
      console.log(this.time_slot[partTime][index].isActive)
    },
    submitFn: function() {
      //点击提交

      if (this.select_time == '') {
        //如果没有选择时间段提示
        this.$message.error('Please choose the interview time!')
        return
      }

      let interview_time = this.calendar.items.value + ' ' + this.select_time //选择的日期和时间段
      this.$http
        .get(
          '/interview/reschedule' +
            '?interview_time=' +
            interview_time +
            '&time_zone=' +
            this.time_zone +
            '&type=I'
        )
        .then(
          function(d) {
            if ((d.data.res = 75000)) {
              this.$router.push('/interview?status=assigned') //跳转到结果页（选完时间页面）
            }
          },
          function() {
            console.log('error')
          }
        )
    }
  },
  computed: {
    disableDate: function() {
      '' +
        addZero(new Date().getFullYear()) +
        '-' +
        addZero(new Date().getMonth() + 1) +
        '-' +
        addZero(new Date().getDate())
    }
  }
}
</script>
<style lang='less' scoped>
.b_inter_wrap {
  width: 1000px;
  margin: 0 auto;
  & > img {
    padding-top: 57px;
  }
  .book_date {
    padding-top: 55px;
    & > h4 {
      font-size: 24px;
      color: #febf00;
      margin-bottom: 30px;
    }
    .el-select {
      margin-top: 0;
      width: 338px;
    }
    .timeZone {
      height: 40px;
      dt {
        float: left;
        width: 338px;
      }
      dd {
        margin-left: 358px;
        line-height: 18px;
        font-size: 14px;
        padding-top: 2px;
      }
    }
    .date_detail {
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      height: 500px;
      margin-top: 21px;
      & > * {
        float: left;
      }
      .calendar_wrapper {
        position: relative;
        height: 100%;
        width: 338px;
        background: #f7f7f7;
        vertical-align: middle;
      }
      .date_time {
        width: 660px;
        height: 500px;
      }
      .time_quantum {
        width: 660px;
        height: 100%;
        background-image: none;
        & > li {
          float: left;
          height: 100%;
          width: 220px;
          & > h4 {
            padding-top: 34px;
            text-align: center;
            font-size: 18px;
            color: #525252;
          }
          ul.time_list {
            height: 429px;
            padding-top: 19px;
            width: 100%;
            float: left;
            padding-left: 17px;
            overflow: auto;
            & > li {
              border: 1px solid #fcc800;
              border-radius: 10px;
              float: left;
              width: 87px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 13px;
              color: #ffb400;
              margin: 0 auto;
              margin-bottom: 9px;
              cursor: pointer;
              &:nth-child(odd) {
                margin-right: 10px;
              }
              &.active {
                color: #1e1e1e;
                background: #ffb400;
                font-weight: bold;
              }
            }
          }
        }
      }
      .no_times {
        padding-top: 50px;
        text-align: center;
        width: 100%;
      }
    }
  }
  a.submit {
    display: block;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 101px;
    margin-bottom: 145px;
    font-size: 24px;
    height: 46px;
    width: 337px;
    border-radius: 10px;
    text-align: center;
    line-height: 46px;
    background: #fcc800;
    color: #1e1e1e;
  }
}
</style>
<style lang='less'>
.book_date {
  .calendar {
    padding: 0!Important;
    margin: 10px;
    margin-top: 30px!Important;
    margin-left: 18px;
    border: 1px solid #cccccc;
    border-radius: 10px 10px 0 0!Important;
    overflow: hidden;
    table {
      thead {
        td {
          color: #ffb400;
        }
      }
      td {
        font-size: 13px;
        span {
          width: 36px!Important;
          height: 36px!Important;
          line-height: 36px!Important;
          border-radius: 100%;
          &:hover {
            background: #fff9e5!Important;
            color: #000!Important;
          }
        }
      }
      td.selected {
        span {
          background: #fcc800;
          border-radius: 100%;
          &:hover {
            background: #fcc800;
          }
        }
      }
    }
  }
  .calendar:after {
    display: none;
  }
  .calendar:before {
    display: none;
  }
  .calendar td.selected span:hover {
  }
  div.calendar-tools {
    height: 43px;
    line-height: 43px;
    background: #525252;
    i.glyphicon-menu-left,
    i.glyphicon-menu-right {
      margin: 0 25px;
    }
    i.glyphicon-menu-left:before,
    i.glyphicon-menu-right:before {
      color: #fff;
      font-size: 14px;
    }
    & > div {
      color: #fff;
      font-size: 18px;
      cursor: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// book.vue?22da2814